
// Better wirte your code in original Javascript with the least dependency


var getHost = function(ori){
	var dest = '';
    if (location.hostname.indexOf('dianping.com') >= 0) {
    	ori = ori.replace('51ping.com','dianping.com');
		if (/^ppe\./.test(location.hostname)) {
			dest = ori.replace('//','//ppe.');
		}else{
			dest = ori.replace('//ppe.','//');
		}
    } else {
    	dest = ori.replace('dianping.com','51ping.com');
    }
    return dest;
}
var BaseEnv = function(ori){
	return getHost(ori);
}

BaseEnv.getHost = function(ori){
	return getHost(ori);
}

module.exports = BaseEnv;


// WEBPACK FOOTER //
// ./~/@dp/base-env/src/base-env.js